import { CR_SUBMISSION } from '../../constants';
import { parseReviewFormData } from './parse-review-form-data';

export type GetReviewFormDataParams = {
    rootElement: Pick<HTMLElement, 'querySelector'>;
};

export const getReviewFormData = async ({ rootElement }: GetReviewFormDataParams) => {
    const formElement = rootElement.querySelector<HTMLFormElement>(CR_SUBMISSION.PAGE.FORM_SELECTOR);
    if (formElement === null) {
        throw new Error('Form element not found');
    }

    const formDataDOM = new FormData(formElement);
    const formDataRaw: Record<string, unknown> = {};

    formDataDOM.forEach((value: FormDataEntryValue, key: string) => {
        if (typeof value === 'string') {
            formDataRaw[key] = value;
        } else if (typeof value === 'object' && value instanceof File && value.size > 0) {
            if (formDataRaw[key]) {
                formDataRaw[key] = [...(formDataRaw[key] as File[]), value];
            } else {
                formDataRaw[key] = [value];
            }
        }
    });

    return parseReviewFormData(formDataRaw);
};
